<template>
    <b-card no-body>

        <b-modal size="lg" id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <part-of-create-or-update v-model="partOf" :editing="editing" :errors="errors"></part-of-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :buttons="buttons"
                    name="part-of"
                    :add-callback="createNew"
                    search
                    pagination="server"
                    :fields="fields">
                        <template #additional-actions>
                            <b-dropdown variant="dark">
                                <template #button-content>
                                    <feather-icon icon="FilterIcon" class="mr-50"></feather-icon>
                                    Filtrele
                                </template>
                                <div class="pr-50 pl-50">
                                    <part-of-filter v-on:filter="filter($event)"></part-of-filter>
                                </div>
                            </b-dropdown>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import {BCard,BDropdown} from 'bootstrap-vue'
import PartOfCreateOrUpdate from './components/PartOfCreateOrUpdate.vue'
import MaintenanaceOperationsApi from '@/api/maintenance-operations'
import PartOfFilter from './components/PartOfFilter.vue'

export default {
    components:{
        BCard,
        BDropdown,
        PartOfCreateOrUpdate,
        PartOfFilter,
    },
    data(){
        return{
            fields:[
                {name:"Eski Stok Kodu",key:"StockCode",thClass:"w-10",sortable:true},
                {name:"Sistem Stok Kodu",key:"SystemStockCode",thClass:"w-10",sortable:true},
                {name:"Ana Grup",sortKey:'MainGroupOfMaintenanceInventory.Name', key:"MainGroupOfMaintenanceInventoryName",thClass:"w-15",sortable:true},
                {name:"Alt Grup",sortKey:'SubGroupOfMaintenanceInventory.Name',key:"SubGroupOfMaintenanceInventoryName",thClass:"w-15",sortable:true},
                {name:"Parça",key:"Name",thClass:"w-15",sortable:true},
                {name:"Konum",key:"LocationOfPartCode",thClass:"w-10",sortable:true},
                {name:"Araçlar",key:"Vehicles",thClass:"w-25",component:true,componentOptions:{name:"maintenance-operations/PartOfVehicles"}}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            filters:{},
            partOf:{
                Id:null,
                Name:null,
                MainGroupOfMaintenanceInventoryId:null,
                SubGroupOfMaintenanceInventoryId:null,
                StockCode:null,
                LocationOfPart1:0,
                LocationOfPart2:0,
                LocationOfPart3:0,
                LocationOfPart4:0,
                LocationOfPart5:0,
                LocationOfPart6:0,
                VehicleIds:[],
                IsGlobalPart:false
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.partOf.Id = null
            this.partOf.Name = null
            this.partOf.MainGroupOfMaintenanceInventoryId = null
            this.partOf.SubGroupOfMaintenanceInventoryId = null
            this.partOf.StockCode = null
            this.partOf.LocationOfPart1 = 0
            this.partOf.LocationOfPart2 = 0
            this.partOf.LocationOfPart3 = 0
            this.partOf.LocationOfPart4 = 0
            this.partOf.LocationOfPart5 = 0
            this.partOf.LocationOfPart6 = 0
            this.partOf.VehicleIds = []
            this.partOf.IsGlobalPart=false
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.partOf.Id = item.Id
            this.partOf.Name = item.Name
            this.partOf.MainGroupOfMaintenanceInventoryId = item.MainGroupOfMaintenanceInventoryId
            this.partOf.SubGroupOfMaintenanceInventoryId = item.SubGroupOfMaintenanceInventoryId
            this.partOf.StockCode = item.StockCode
            this.partOf.LocationOfPart1 = item.LocationOfPart1
            this.partOf.LocationOfPart2 = item.LocationOfPart2
            this.partOf.LocationOfPart3 = item.LocationOfPart3
            this.partOf.LocationOfPart4 = item.LocationOfPart4
            this.partOf.LocationOfPart5 = item.LocationOfPart5
            this.partOf.LocationOfPart6 = item.LocationOfPart6
            this.partOf.VehicleIds = item.VehicleIds
            this.partOf.IsGlobalPart = item.IsGlobalPart
            this.$showModal("create-or-update")
        },
        createNew(){
            this.clearForm()
            this.$showModal("create-or-update")
        },
        filter(filter){
            this.filters = filter
            this.$refs.table.refresh()
        },
        provider(data){
            return MaintenanaceOperationsApi.PartOf.Table({PaginationRequestModel:data,...this.filters})
        },
        createOrUpdate(){
            this.loading = true
            MaintenanaceOperationsApi.PartOf.CreateOrUpdate(this.editing,this.partOf).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal("create-or-update")
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli parçayı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    MaintenanaceOperationsApi.PartOf.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>